import { PublicTenders } from './PublicTenders';

export function PublicLotsPage() {
  return <PublicTenders type="lots" />;
}
